<script lang="ts" setup>
  import { computed } from 'vue'
  import {
    DEFAULT_OPTIONS_COUNT,
    OPTION_KEY_TITLE,
    OPTION_KEY_VALUE,
    OPTION_KEY_SEARCH,
    NATIONALITY_MASK,
  } from './NationalityInput.constants'
  import type { Option } from './NationalityInput.types'
  import NewSelect from '@/widgets/Flow/NewBaseSelect/NewBaseSelect.vue'

  // TODO: Think about. Maybe we need make a request to gettinf nationalities inside this component?
  interface Props {
    modelValue: string
    options: Option[]
    errors?: string[]
    label?: string
    dataTest?: string
  }
  interface Emits {
    (e: 'update:modelValue', nationality: string): void
  }

  const props = withDefaults(defineProps<Props>(), {
    modelValue: '',
    dataTest: 'nationality-input',
  })

  const emit = defineEmits<Emits>()

  const value = computed({
    get: () => props.modelValue,
    set: (value) => {
      emit('update:modelValue', value)
    },
  })
</script>

<template>
  <NewSelect
    v-model="value"
    :data-test="dataTest"
    class="nationality-input__select"
    :label="label || $t('outbound_nationality_nationality')"
    :options="options"
    :option-title="OPTION_KEY_TITLE"
    :option-value="OPTION_KEY_VALUE"
    :option-search="OPTION_KEY_SEARCH"
    :num-options-in-scroll="DEFAULT_OPTIONS_COUNT"
    :errors="errors"
    filterable
    sort-by="startsWith"
    :disabled="options.length === 0"
    :mask="NATIONALITY_MASK.value"
    :mask-tokens="NATIONALITY_MASK.tokens"
  />
</template>

<style>
  /* TODO: Fix bug that all options is always marked as selected. (This style is hack to fix it) */
  .nationality-input__select .base-select__option_selected {
    color: inherit;
  }

  .nationality-input__select .base-select-control__current-value {
    font-size: 16px;
  }
</style>

<style lang="scss" scoped>
  @import './NationalityInput';
</style>
